import React from 'react';
import BuilderSectionCard from '../../../BuilderSectionCard';
import ExpandEventInput from './ExpandEventInput';

interface IProps {
  index: number;
}

const ExpandEvent = ({ index }: IProps) => {
  return (
    <BuilderSectionCard
      iconName="expand-event-active"
      iconPositiveIndex={index + 1}
      gap={8}
    >
      <ExpandEventInput index={index} />
    </BuilderSectionCard>
  );
};

export default ExpandEvent;
